<template>
    <v-layout row wrap class="mb-2 mt-2 border">
        <v-flex>
            <v-text-field
                v-if="relationshipList.length === 0"
                class="ucFirst body-2"
                :label="label"
                :outlined="outlined"
                :append-icon="appendIcon"
                :value="value"
                :color="$vuetify.theme.primary"
                :background-color="$vuetify.theme.primary"
                :data-testid="metadata.name"
                :name="metadata.name"
                :maxlength="maxLength"
                counter
                :rules="[
                    !required || requiredField()
                ]"
                :data-meta-id="metadata.id"
                :id="metadata.name"
                @change="emitValue"
            />
            <v-autocomplete
                v-else
                :value="value"
                :items="relationshipList"
                item-text="type"
                item-value="type"
                :data-testid="metadata.name"
                :outlined="outlined"
                :color="$vuetify.theme.primary"
                :background-color="$vuetify.theme.primary"
                :append-icon="appendIcon"
                :label="label"
                :rules="[
                    !required || requiredField()
                ]"
                class="body-2 tz-dropdown"
                :data-meta-id="metadata.id"
                :id="metadata.name"
                @change="emitValue"
            >
                <template v-slot:item="props">
                    <template>
                        <v-list-tile-content>
                            <v-list-tile-title>
                                <span v-if="props.item.type">
                                    {{ getRelationshipListLabelOrOriginalValue(props.item.type) }}
                                </span>
                            </v-list-tile-title>
                        </v-list-tile-content>
                    </template>
                </template>
                <template v-slot:selection="props">
                    <span v-if="props.item.type">
                        {{ getRelationshipListLabelOrOriginalValue(props.item.type) }}
                    </span>
                    <span v-else />
                </template>
            </v-autocomplete>
        </v-flex>
    </v-layout>
</template>

<script>
import { inputHelpers } from '@/mixins/inputHelpers';
import { mapGetters } from 'vuex';
import { formRules } from '@/mixins/form-rules';
import { ServiceSettings } from '@/enums';
import { find, map } from 'lodash';

export default {
    name: 'emergency-contact-relationship',
    mixins: [formRules, inputHelpers],
    props: {
        metadata: { type: Object, required: true },
        outlined: { type: Boolean, required: false, default: true },
        required: { type: Boolean, required: false, default: false },
        value: { type: String, required: false, default: '' },
        withIcon: { type: Boolean, required: false, default: false },
        editMode: { type: Boolean, required: false, default: false },
        readMode: { type: Boolean, required: false, default: false },
    },
    computed: {
        ...mapGetters({
            upperLocale: 'upperLocale',
            getService: 'settings/services/getServiceById',
            getCurrentEstSettings: 'services/getCurrentEstSettings',
        }),
        appendIcon() {
            return this.withIcon ? 'fas fa-wrench' : '';
        },
        relationshipList() {
            let options = find(this.getCurrentEstSettings, ['setting', ServiceSettings.EMERGENCY_CONTACT_RELATIONSHIP]);
            return map(options.value, option => {
                return {
                    type: option,
                };
            });
        },
        label() {
            return (this.required ? '* ' : '') + this.metadata[`description${this.upperLocale}`];
        },
        maxLength() {
            return this.metadata && this.metadata.rules && this.metadata.rules.maxLength;
        },
    },
    methods: {
        emitValue(value) {
            this.$emit('update:value', value);
        },

        getRelationshipListLabelOrOriginalValue(relationshipListKey) {
            const translationKey = `appt.relationshipListLabel.${relationshipListKey}`;
            const result = this.$t(translationKey);
            if (result === translationKey) {
                return relationshipListKey;
            }
            return result;
        },
    },
};
</script>
